import { prefillConnection } from '@/adapter/applicationLoader';
import { useApplication } from '@/hooks/useApplication';
import { useMetadata } from '@/hooks/useMetadata';
import { useUpdateNodes } from '@/hooks/useUpdateNodes';
import { Application } from '@/types/application';
import { IndexPortOption } from '@/types/connection';
import { PortOption } from '@/types/metadata/metadata';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';

type PortSelectProps = {
  id: number;
  ports: PortOption[];
  index: number;
};

const PortSelect: FC<PortSelectProps> = (props) => {
  const { metadata } = useMetadata();
  const { application, setApplication } = useApplication();
  const { setUpdateNodes } = useUpdateNodes();

  const handleChange = (event: SelectChangeEvent) => {
    const newIndex = Number.parseInt(event.target.value);
    if (newIndex === props.index) return; //same selection means no changes.

    const id = props.id.toString();
    const newIndexPortOption: IndexPortOption = {
      index: newIndex,
      label: props.ports[newIndex].label
    };

    const reset: Application = {
      ...application,
      blocks: {
        ...application.blocks,
        //Delete any previous connections, prefillConnection refills them for the new port option
        connections: { ...application.blocks.connections, [id]: [] },
        portoptions: { ...application.blocks.portoptions, [id]: newIndexPortOption }
      }
    };

    setApplication(prefillConnection(reset, metadata, id));
    setUpdateNodes([id]);
  };

  if (props.ports.length < 2) return <></>;
  return (
    <FormControl fullWidth size='small'>
      <InputLabel id='port-select-label'>Select port option</InputLabel>
      <Select
        labelId='port-select-label'
        id='port-select'
        value={props.index?.toString()}
        label='Select port option'
        onChange={handleChange}
      >
        {props.ports.map(
          (port, index) =>
            port.type !== 'nothing' && (
              <MenuItem key={`menuItem.${index}`} value={index}>
                {port.label}
              </MenuItem>
            )
        )}
      </Select>
    </FormControl>
  );
};

export default PortSelect;
